<template>
  <div>
    <div class="title">
      <div class="one"><i class="el-icon-star-on"></i>精选酒店</div>
      <h2>为您推荐</h2>
      <span>严选品质，每一晚都值得期待</span>
    </div>
    <ul class="bottom-display">
      <li  v-for="(hotelBottom,index) in homeHotelOther" :key="index" @click="viewDetails(hotelBottom)">
        <div class="bottom-display-img">
          <img v-lazy="ImgPreUrl + hotelBottom.pic" class="bottom-small"/>
        </div>
        <div class="bottom-display-info">
          <div class="name">
            {{hotelBottom.title}}
            <img v-lazy="'/images/zfxj/icon_'+hotelBottom.star+'.png'" :key="hotelBottom.state_star" height="15px" v-if="hotelBottom.state_star>0"/>
            <img v-lazy="'/images/xj/icon_'+hotelBottom.star+'.png'" :key="hotelBottom.star" height="15px" v-else />
          </div>
          <div class="star-info">
            <div class="star-text">{{hotelBottom.star | formatVar('HotelStar')}}</div>
          </div>
          <div class="address">
            <i class="el-icon-location-information text-login mr-1"></i>
            <p>{{ parseAddress(hotelBottom) }}</p>
          </div>
          <el-button class="mb-4 bottom"  style="width:90%;">立即查看</el-button>
        </div>
      </li>
    </ul>
    <!-- <header-nav type="酒店" routeTo="/index/index_hotel/hotel_list_map"/> -->
    <!--主体展示内容-->
    <!-- <div class="display-bg"> 
      <div class="bottom-display d-flex">
        <div v-for="(hotelBottom,index) in homeHotelOther" class="bottom-small" :key="index"
             @mouseenter="bottomIndex=index" @mouseleave="bottomIndex=''">
          <div v-show="bottomIndex===index" class="hove-homestay">
            <h4>{{hotelBottom.title}}</h4>
        
            <router-link :to="'/index_hotel/hotel_detail/'+hotelBottom.custom" class="more">了解更多
            </router-link>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import provinces from '@/assets/utils/provinces'             //省份信息
import EleCarousel from "./../IndexPage/EleCarousel";
import HeaderNav from "./HeaderNav";

export default {
  name: "RecommendHotel",
  components: { EleCarousel, HeaderNav },
  props: {
    homeScrollHotel: {
      type: Array,
      default: () => {
        return [];
      }
    },
    homeHotelOther: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      bottomIndex: "",
      rightIndex: ""
    };
  },
  methods: {
    //获取本地地址信息
    parseAddress(res){
      let city = provinces.find(item => item.id == res.city);
      let district = provinces.find(item => item.id == res.district);
      return `${city.title}${district.title}${res.address}`;
    },
    //查看详情
    viewDetails(item){
        let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.custom);
        window.open(changeRoute.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
  .title{
    text-align: left;
  }
  .title h2{
    font-size: 22px;
  }
  .title span{
    color: #999;
  }
  .title .one{
    color: var(--smtc-color-primary);
    display: flex;
    i{
      font-size: 20px;
    }
  }
  .star-info{
    text-align: left;
    margin-top: 6px;
    display: flex;
    margin-bottom: 6px;
    img{
      margin-top: 4px;
      margin-right: 6px;
    }
  }
  .bottom-display{
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }
  .bottom-display li{
    width: 22.6%;
    box-shadow: 0px 0px 7px #eee;
    margin-right: 3.2%;
    background-color: #fff;
    overflow: hidden;
    border-radius: 16px;
    margin-bottom: 36px;
    cursor: pointer;
    transition: all 0.3s ease;
    height: 400px;
    position: relative;
    .bottom{
      position: absolute;
      bottom: 0;
      left: 5%;
      width: 90%;
    }
  }
  .bottom-display li:nth-child(4n){
    margin-right: 0;
  }
  .bottom-display-img{
    position: relative;
    height: 100%;
    height: 170px;
    overflow: hidden;
    img{
      height: 170px;
      width: 100%;
      transition: transform 0.25s ease;
    }
  }
  .bottom-display li:hover{
    box-shadow: 0px 0px 10px #ccc;
  }
  .bottom-display-img:hover img{
    transform: scale(1.1);
  }
  .bottom-display li:hover .bottom {
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
  .bottom-display-info{
    width: 90%;
    margin: 0 auto;
    text-align: left;
    span{
      display: inline-block;
    }
    img{
      margin-left: 4px;
      display: inline-block;
      margin-top: 4px;
    }
    .name{
      font-size: 15px;
      font-weight: bold;
      margin: 8px 0;
      text-align: left;
      width: 100%;
      align-items: center;  /* 垂直居中 */
    }
    .address{
      text-align: left;
      margin-bottom: 36px;
      height: 45px;
      overflow: hidden;
      display: flex;
      i{
        margin-top: 4px;
      }
      p{
        width: 90%;
      }
    }
    .botton{
      width: 100% !important;
    }
  }
  .star-text{
    background-color: #eff6ff;
    color: var(--smtc-color-primary);
    padding: 4px 6px;
    font-size: 10px;
    border-radius: 4px;
  }
</style>
